import React from "react";
import { Message } from "components/Atoms/Message";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { routes } from "utilities/routing/generatedRoutes";
import { getInvoiceV1FormSections } from "invoice/getInvoiceV1FormSections";
import { useDocumentV1Form } from "documentV1/hooks";

export const InvoiceV1NewEditSection = () => {
  const hook = useDocumentV1Form({ documentType: "invoice" });

  const submit = async () => {
    return window.CoreApi.Invoice.Create({
      addresseeCompanyId: hook.addressee!.companyId,
      bookkeepingId: hook.bookkeeping!.bookkeepingId,
      currency: hook.currency,
      dueInDays: hook.dueInDays,
      exchangeRate: hook.exchangeRate,
      bankAccountId: hook.bankAccount?.bankAccountId,
      invoiceDate: hook.sendDate.toDate(),
      ownerUserId: hook.owner.userId,
      isDraft: hook.isDraft,
      concerning: hook.concerning,
      contactId: hook.contact?.contactId,
      costCenterId: hook.costCenter?.costCenterId,
    } satisfies Required<server.dto.CreateInvoiceV1Instruction>);
  }

  const sections = getInvoiceV1FormSections(hook);
  sections.fields.push({
    key: "peppol_warning",
    label: "",
    hideLabel: true,
    hidden: hook.bookkeeping == null || hook.bookkeeping.companyAdmCountry !== "belgium",
    renderEditNew: () => (
      <Message type="error">
        {RESX.EInvoicing.PleaseSwitchMessageBelgium}
      </Message>
    )
  });

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={(itemId) => routes.invoiceV1_Detail(itemId).absolute}
    sections={[sections]}
  />
}

export default InvoiceV1NewEditSection;


